import { translate } from "react-i18next";
import GlobalFooter from "./GlobalFooter";

export default translate()(GlobalFooter);
